// The phone breakpoint, shared with the @media (max-width: 640px) rules in cookieConsent.css.
export const MOBILE_QUERY = '(max-width: 640px)';
